import React from 'react';
import {connect} from 'react-redux';
import {Field, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form'
import {Button, Card, CardBody, Col, FormGroup} from 'reactstrap';
import ReduxFormInput from "@Utils/ReduxFormInput";
import validate, { ContestParams } from './validate';
import {ContestParticipationMode} from "@Models";
import ReduxFormDatePicker from "@Utils/ReduxFormDatePicker";
import ReduxFormSelect from "@Utils/ReduxFormSelect";
import {VersionView} from "@Selectors/common/view/VersionView";
import {
  ContestParticipationView
} from "@Selectors/builder/myBuilder/tournament/new/view/ContestParticipationView";
import {AppState} from "@Redux/store";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  versions: Array<VersionView>
  participations: Array<ContestParticipationView>
  cancel: () => void
  onSubmit: (values: any) => void
  canSubmit: boolean
  hideTeam?: boolean
}

const Form: React.FC<Props & InjectedFormProps<ContestParams, Props>> = ({
                                                                           versions,
                                                                           participations,
                                                                           hideTeam,
                                                                           cancel,
                                                                           handleSubmit,
                                                                           canSubmit
                                                                         }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Col sm="12">
        <Card className="card-border">
          <CardBody>
            <h2 className="text-center"><FormattedMessage {...defaultMessages.contestNewTitle} /></h2>
            <h2 className="text-center">This part is currently being completely overhauled, all features are not available or source of errors.</h2>
            <FormGroup row={true}>
              <Col xs="12" md={12} lg="4">
                <Field
                  name="name"
                  type="text"
                  component={ReduxFormInput}
                  label={defaultMessages.contestFormNameTitle}
                  placeHolder={defaultMessages.contestFormNamePlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg="3">
                <Field
                  name="startDate"
                  showTime={false}
                  component={ReduxFormDatePicker}
                  label={defaultMessages.contestFormStartdateTitle}
                  placeHolder={defaultMessages.contestFormStartdatePlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg="3">
                <Field
                  name="endDate"
                  showTime={false}
                  component={ReduxFormDatePicker}
                  label={defaultMessages.contestFormEnddateTitle}
                  placeHolder={defaultMessages.contestFormEnddatePlaceholder}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" lg="6">
                <Field
                  name="versionId"
                  datas={versions}
                  multiple={false}
                  component={ReduxFormSelect}
                  label={defaultMessages.contestFormVersionidTitle}
                  placeHolder={defaultMessages.contestFormVersionidPlaceholder}
                />
              </Col>
              <Col xs="12" lg="6">
                <Field
                  name="armyListMax"
                  type="number"
                  component={ReduxFormInput}
                  label={defaultMessages.contestFormArmylistmaxTitle}
                  placeHolder={defaultMessages.contestFormArmylistmaxPlaceholder}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" lg="6">
                <Field
                  name="participation"
                  datas={participations}
                  multiple={false}
                  component={ReduxFormSelect}
                  label={defaultMessages.contestFormParticipationTitle}
                  placeHolder={defaultMessages.contestFormParticipationPlaceholder}
                />
              </Col>
              <Col xs="12" lg="6" hidden={hideTeam}>
                <Field
                  name="teamMax"
                  type="number"
                  component={ReduxFormInput}
                  label={defaultMessages.contestFormTeammaxTitle}
                  placeHolder={defaultMessages.contestFormTeammaxPlaceholder}
                />
              </Col>
              <Col xs="12" lg="6">
                <Field
                  name="userMax"
                  type="number"
                  component={ReduxFormInput}
                  label={defaultMessages.contestFormUsermaxTitle}
                  placeHolder={defaultMessages.contestFormUsermaxPlaceholder}
                />
              </Col>
            </FormGroup>

          </CardBody>
          <div className="mb-2 text-center">
            <Button disabled={!canSubmit} onClick={() => cancel()} color="age"
                    type="button"><FormattedMessage {...defaultMessages.formCancel} /></Button>
            <Button disabled={!canSubmit} color="age" type="submit"><FormattedMessage {...defaultMessages.formCreate} /></Button>
          </div>
        </Card>
      </Col>
    </form>
  );
}

const NewContestForm = reduxForm<ContestParams, Props>({
  form: 'new_contest',
  validate,
})(Form);

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('new_contest') // <-- same as form name

const mapStateToProps = (state: AppState, props: Props) => {
  return {
    hideTeam: selector(state, 'participation') != ContestParticipationMode.TEAM,
    versions: props.versions,
    participations: props.participations,
    cancel: props.cancel,
    onSubmit: props.onSubmit,
    canSubmit: props.canSubmit,
    initialValues: {
      armyListMax: 4500,
      participation: ContestParticipationMode.INDIVIDUAL,
    },
  }
}

export default connect(mapStateToProps)(NewContestForm);
